// extracted by mini-css-extract-plugin
module.exports = {"tagMenu":"TagMenu_tagMenu__12VN5","tabList":"TagMenu_tabList__3aFGq"};